import React, { useState } from 'react';
import { Badge, Popover } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { useCart } from '../contexts/CartContext';
import CartPopover from './CartPopover';

const CartIcon: React.FC = () => {
  const { itemCount, isLoading } = useCart();
  const [popoverVisible, setPopoverVisible] = useState(false);

  // Don't render until cart is loaded
  if (isLoading) {
    return (
      <div style={cartIconContainer}>
        <ShoppingCartOutlined style={cartIconStyle} />
      </div>
    );
  }

  return (
    <Popover
      content={<CartPopover onClose={() => setPopoverVisible(false)} />}
      title="Shopping Cart"
      trigger="click"
      open={popoverVisible}
      onOpenChange={setPopoverVisible}
      placement="bottomRight"
    >
      <div style={cartIconContainer}>
        <Badge 
          count={itemCount} 
          size="small"
          style={{ backgroundColor: '#f5a623' }}
          showZero={false}
        >
          <ShoppingCartOutlined style={cartIconStyle} />
        </Badge>
      </div>
    </Popover>
  );
};

const cartIconContainer: React.CSSProperties = {
  cursor: 'pointer',
  padding: '8px',
  borderRadius: '4px',
  transition: 'background-color 0.3s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const cartIconStyle: React.CSSProperties = {
  fontSize: '20px',
  color: '#E6EBFA',
};

export default CartIcon;